/**
 * Eventos personalizados para notificação de mudanças no estado de autenticação.
 *
 * Histórico (G-23, G-24 — web-plataforma-adjustments Wave 4, 2026-05-26):
 * Antes este arquivo configurava interceptors globais em `axios` para JWT e
 * refresh-token. Os interceptors duplicavam o que `BaseApiService.createApi`
 * já faz por instância (`propertyApi`, `authApi`, `municipalitiesApi`) —
 * gerando duplo `Authorization` em chamadas que usavam essas instâncias e
 * zero efeito em chamadas que usavam `axios` direto (nenhuma mais existe no
 * `src/` após Waves 1-3). A função `refreshToken` era um
 * stub que sempre lançava porque o backend `gn-api-auth-service` não tem
 * endpoint de refresh — apenas mantida por compatibilidade de import.
 *
 * Mantemos apenas os Event objects + função `refreshToken` (lança imediato)
 * porque `useAuth.jsx`, `AuthService.jsx`, `LoginForm.jsx` ainda importam
 * desses símbolos.
 */

export const authEvents = {
  logout: new Event('auth:logout'),
  login: new Event('auth:login'),
  tokenRefreshed: new Event('auth:token_refreshed'),
};

/**
 * Stub mantido para compatibilidade de import em `useAuth.jsx`. Backend
 * `gn-api-auth-service` não possui endpoint de refresh-token. Em caso de
 * 401, as instâncias `createApi(...)` de `BaseApiService.jsx` fazem
 * `clearJwt()` + dispatch de `auth:logout` automaticamente.
 */
export async function refreshToken() {
  throw new Error('Refresh token não implementado no backend');
}
